export default "__VITE_PUBLIC_ASSET__ff3c2dfb__"